<template>
<div class="container-img64">
  <VPerfectSignature
    ref="signaturePad"
    class="signatureDigital"
    :stroke-options="strokeOptions"
    backgroundColor='rgba(255, 255, 255, 1)'
  /><br>
  <div class="buttonsOptions">
    <el-button
      size="mini"
      round
      @click="toDataURL">Guardar</el-button>
    <el-button
      size="mini"
      round
      @click="clear">Limpiar</el-button>
  </div>
  <!-- <label>Visualizacion</label>
  <div class="signature-img">
    <img
      v-if="signature.image"
      :src="`${signature.image}`"
      id="img-base"
    >
  </div> -->
</div>
</template>

<script>
import VPerfectSignature from 'v-perfect-signature';

export default {
  data() {
    return {
      strokeOptions: {
        size: 10,
        thinning: 0.50,
        smoothing: 0.50,
        streamline: 0.20,
      },
      signature: {
        id: '',
        image: '',
      },
    };
  },
  components: {
    VPerfectSignature,
  },
  methods: {
    clear() {
      this.$refs.signaturePad.clear();
    },
    saveSignature() {
      try {
        // console.log('resultado: ', dataURL);
      } catch (e) {
        // some code
      }
    },
    toDataURL() {
      const dataURL = this.$refs.signaturePad.toDataURL();
      if (dataURL === undefined) {
        this.signature.image = '';
      } else {
        this.signature.image = this.$refs.signaturePad.toDataURL('image/png');
        this.saveSignature(dataURL);
        // console.log(this.$refs.signaturePad.toDataURL('image/png'));
      }
    },
  },
  // mounted() {
  //   console.log('refs', this.$refs.signaturePad);
  // },
};
</script>

<style lang="scss">
.container-img64{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .buttonsOptions {
    display: flex;
    flex-direction: row;
  }
}
.signature-img {
  display: flex;
  justify-content: center;
  border: 1px solid rgb(218, 218, 218);
  background-color: rgb(255, 255, 255);
  width: 100%;
}
.signatureDigital {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgb(223, 223, 223);
  border-radius: 15px;
}
#img-base {
  width: 20%;
}
</style>
